var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"total-wrap flex-align-between"},[_c('div',{staticClass:"course-count"},[_c('div',{staticClass:"course_chart",attrs:{"id":"course_chart"}})]),_c('div',{staticClass:"video-count"},[_c('div',{staticClass:"video_chart",attrs:{"id":"video_chart"}})])])
}]

export { render, staticRenderFns }